import React, { useState, useEffect, useRef } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import AllPerperties from './AllPerperties'
import Logo from '../../assets/images/800home/Logo.webp'
import { Spinner } from 'react-bootstrap'
import { usePropertiesContext } from '../../context/PropertiesContext'
import { useLocation } from 'react-router-dom'

const ITEMS_PER_PAGE = 15

const MainPageOfListing = () => {
    const { properties, loading } = usePropertiesContext()
    const location = useLocation()
    const [tabIndex, setTabIndex] = useState(0) // Default to 'All Properties' tab
    const [allProperties, setAllProperties] = useState([])
    const [apartmentsData, setApartmentsData] = useState([])
    const [townhousesData, setTownhousesData] = useState([])
    const [villasData, setVillasData] = useState([])
    const [penthousesData, setPenthousesData] = useState([])
    const [allPage, setAllPage] = useState(0)
    const [apartmentsPage, setApartmentsPage] = useState(0)
    const [townhousesPage, setTownhousesPage] = useState(0)
    const [villasPage, setVillasPage] = useState(0)
    const [penthousesPage, setPenthousesPage] = useState(0)

    const propertiesTopRef = useRef(null)

    // Parse query parameters for tab selection
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const tabParam = searchParams.get('tab')

        // Always scroll to top (0,0) when coming from a link
        window.scrollTo(0, 0)

        if (tabParam) {
            // Set the tab index based on the URL parameter
            switch (tabParam.toLowerCase()) {
                case 'apartment':
                    setTabIndex(1)
                    break
                case 'penthouse':
                    setTabIndex(2)
                    break
                case 'townhouse':
                    setTabIndex(3)
                    break
                case 'villa':
                    setTabIndex(4)
                    break
                // Default to 'All Properties'
                default:
                    setTabIndex(0)
            }
        } else {
            // Explicitly set to 'All Properties' tab when there is no tab parameter
            setTabIndex(0)
        }
    }, [location])

    useEffect(() => {
        if (properties && properties.length > 0) {
            setAllProperties(properties)
            setApartmentsData(properties.filter((property) => property.type === 'apartment'))
            setTownhousesData(properties.filter((property) => property.type === 'townhouse'))
            setVillasData(properties.filter((property) => property.type.id === 'villa')) // assuming villa id is 5
            setPenthousesData(properties.filter((property) => property.type.id === 'penthouse')) // assuming penthouses id is 3
        }
    }, [properties])

    const sliceData = (data, page) => data.slice(page * ITEMS_PER_PAGE, (page + 1) * ITEMS_PER_PAGE)

    const handleScrollToTop = () => {
        if (propertiesTopRef.current) {
            propertiesTopRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    const renderPagination = (data, currentPage, setPage) => {
        const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE)
        if (totalPages <= 1) return null // Hide pagination if items are fewer than the page count

        return (
            <div className="pagination-controls">
                <button
                    disabled={currentPage === 0}
                    onClick={() => {
                        setPage((prev) => prev - 1)
                        handleScrollToTop()
                    }}
                >
                    Previous
                </button>
                {[...Array(totalPages).keys()].map((page) => (
                    <button
                        key={page}
                        className={currentPage === page ? 'active px-3' : 'px-3'}
                        onClick={() => {
                            setPage(page)
                            handleScrollToTop()
                        }}
                    >
                        {page + 1}
                    </button>
                ))}
                <button
                    disabled={currentPage + 1 >= totalPages}
                    onClick={() => {
                        setPage((prev) => prev + 1)
                        handleScrollToTop()
                    }}
                >
                    Next
                </button>
            </div>
        )
    }

    return (
        <div id="website-responsive" className="py-5" ref={propertiesTopRef}>
            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                <TabList className="text-center fs-ss-18 fw-300 mx-auto">
                    <Tab>All Properties</Tab>
                    <Tab>Apartments</Tab>
                    <Tab>Penthouses</Tab>
                    <Tab>Townhouses</Tab>
                    <Tab>Villas</Tab>
                </TabList>

                <section className="container-fluid px-md-0 pt-md-2">
                    {loading ? (
                        <div className="text-center fs-ss-18 lh-1-7em fw-300 col-md-8 mx-auto text-white py-5">
                            <img src={Logo} alt="Logo" width={70} className="loader" />
                            <div className="mt-2">
                                <Spinner animation="grow" size="sm" variant="light" />
                            </div>
                        </div>
                    ) : (
                        <>
                            <TabPanel>
                                <div className="row">
                                    <AllPerperties data={sliceData(allProperties, allPage)} />
                                    {renderPagination(allProperties, allPage, setAllPage)}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <AllPerperties data={sliceData(apartmentsData, apartmentsPage)} />
                                    {renderPagination(apartmentsData, apartmentsPage, setApartmentsPage)}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <AllPerperties data={sliceData(penthousesData, penthousesPage)} />
                                    {renderPagination(penthousesData, penthousesPage, setPenthousesPage)}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <AllPerperties data={sliceData(townhousesData, townhousesPage)} />
                                    {renderPagination(townhousesData, townhousesPage, setTownhousesPage)}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="row">
                                    <AllPerperties data={sliceData(villasData, villasPage)} />
                                    {renderPagination(villasData, villasPage, setVillasPage)}
                                </div>
                            </TabPanel>
                        </>
                    )}
                </section>
            </Tabs>
        </div>
    )
}

export default MainPageOfListing
